import { default as NextLink } from 'next/link';
import { FC } from 'react';
import { FontSize, FontWeight, GeneralColors } from '../../../theme';
import { A } from './style';

interface LinkProps {
  children: React.ReactNode;
  href: string;
  weight?: FontWeight;
  size?: FontSize;
  color?: GeneralColors;
  disableBorderOnHover?: boolean;
  fullWidth?: boolean;
  block?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

const Link: FC<LinkProps> = ({
  href,
  children,
  weight,
  size,
  color,
  disableBorderOnHover,
  fullWidth,
  block,
  target = '_self',
}) => {
  return (
    <NextLink href={href} passHref>
      <A
        weight={weight}
        size={size}
        color={color}
        disableBorderOnHover={disableBorderOnHover}
        fullWidth={fullWidth}
        block={block}
        target={target}
      >
        {children}
      </A>
    </NextLink>
  );
};

export default Link;
